module.exports = __webpack_public_path__ + "img/Dompetkilat-Image@3x.0c076ea5.png";